// @flow
import React from 'react'
import { Wrapper, Text } from './styles'

type Props = {
  bold?: boolean,
  hasFreeLabel?: boolean,
  text: string,
  value: number
}

const Item = (props: Props) => (
  <Wrapper darker={props.bold}>
    <Text bold={props.bold}>{props.text}</Text>
    <Text variant={props.bold}>
      {props.hasFreeLabel && props.value === 0 ? 'Gratis' : `${props.value}`}
    </Text>
  </Wrapper>
)

export default Item
